export enum PamDecisionAction {
  APPROVE = 'approve',
  DENY = 'deny',
  UNLOCK = 'unlock',
}

export enum PamActionStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  ERROR = 'error',
}
